import React from 'react';
import arrowRight from '../../assets/arrow-right.svg';
import arrowLeft from '../../assets/arrow-left.svg';
import moment from 'moment';
import loader from '../../assets/loader.svg';
import smallLoader from '../../assets/loader-small.svg';
import EditAppointment from '../patientProfile/AddEditAppointment';
import Modal from '../modal/Modal';
import { baseUrl } from '../url';
import { Redirect } from 'react-router-dom';

class List extends React.Component{
    state = {
        thisMonth: moment().format('YYYY-MM'),
        currentDate: moment().format('YYYY-MM-DD'),
        currentPage: 1,
        days: 7, 
        response: true,
        moreResponse: false,
        show: false,
        loadMore: true,
        startOfMonth: false,
        appointments: [],
        editDetails: '',
    }
    componentDidMount(){
        this.fetchAppointments();
    }
    fetchAppointments(){
        const { thisMonth, currentPage } = this.state;
        const month = moment(thisMonth).format('MMMM YYYY');
        if(currentPage === 1){
            this.setState({
                response: false,
            })
        }

        let retries = 0;
        const token = localStorage.getItem('access_token');
        const url = `${baseUrl}/admin/appointments?view=list&month=${month}&page=${currentPage}`;
        fetch(url,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            if(response.status === 403){
                localStorage.removeItem('access_token');
                return <Redirect to='/login' />
            }
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
                appointments: [...this.state.appointments, ...responseJson.data],
                totalPages: responseJson.meta.last_page,
                loadMore: true,
                moreResponse: true
            })
            if(currentPage === 1){
                this.setState({
                    more: responseJson.meta.total - 10,
                    response: true,
                })
            }
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    incrementMonth = () => {
        let thisMonth =  this.state.thisMonth,
            today = moment(thisMonth),
            lastMonth = today.add(1, 'month').endOf('month');
        
        this.setState({
            currentDate: lastMonth.format('YYYY-MM-DD'),
            thisMonth: lastMonth.format('YYYY-MM'),
            response: false,
            days: 7,
            startOfMonth: false,
            appointments: [],
            currentPage: 1,
        },() => {
            this.fetchAppointments();
        });
    }
    decrementMonth = () => {
        let thisMonth =  this.state.thisMonth,
            today = moment(thisMonth),
            lastMonth = today.subtract(1, 'month').endOf('month');
        this.setState({
            currentDate: lastMonth.format('YYYY-MM-DD'),
            thisMonth: lastMonth.format('YYYY-MM'),
            response: false,
            days: 7,
            startOfMonth: false,
            appointments: [],
            currentPage: 1,
        },() => {
            this.fetchAppointments();
        });
    }
    loadMore = () => {
        let nextPage = this.state.currentPage + 1;

        if(nextPage <= this.state.totalPages){
            this.setState({
                currentPage: this.state.currentPage + 1,
                more: this.state.more - 10,
                moreResponse: false
            }, () => { this.fetchAppointments() })
        }
    }
    handleChange = () => {

    }
    
    showModal = (appointment) => {
        this.setState({ 
            show: true,
            editDetails: appointment,
        });
    };
    hideModal = () => {
        this.setState({
            show: false,
            appointments: [],
        }, () => { this.fetchAppointments() });
    };
    render(){
        const { appointments, more, response, moreResponse, show, editDetails } = this.state;
        return(
            <div className="list-view">
                <div className="container-fluid">
                    <div className="date-month">
                            <button className="button" 
                                onClick={this.decrementMonth}>
                                <img src={arrowLeft} alt=""/>
                            </button>
                            <input type="month" name="bdaymonth" value={this.state.thisMonth} onChange={this.handleChange}/>
                            <button className="button"
                                onClick={this.incrementMonth}>
                                <img src={arrowRight} alt=""/>
                            </button>
                    </div>
                    {
                        !response &&
                        <div className="loader">
                            <img src={loader} alt=""/>
                        </div>
                    }
                    {
                        response && appointments.length === 0 &&
                        <div className="loader">
                            <h6>No appointments set for this month.</h6>
                        </div>
                    }
                    {
                        appointments.length > 0 && 
                        <React.Fragment>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Patient Name</th>
                                        <th>Alias</th>
                                        <th>Description</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                    </tr>
                                    {
                                        appointments.map(appointment => {
                                            const { patient, description, date, time, id } = appointment;
                                            const name = `${patient.name.first} ${patient.name.last}`;
                                            const alias = patient.alias;
                                            return (
                                                <tr key={id}>
                                                    <td>{name}</td>
                                                    <td>{alias}</td>
                                                    <td>{description}</td>
                                                    <td>{date}</td>
                                                    <td>{time}</td>
                                                    <td><button onClick={() => this.showModal(appointment)}>Edit</button></td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                            <Modal show={show} handleClose={this.hideModal}>
                                {show && <EditAppointment title='Edit Appointment' type="edit" details={editDetails} handleClose={this.hideModal}/>}
                            </Modal>
                            <div className="loader">
                                {
                                    !moreResponse &&
                                    <img src={smallLoader} alt=""/>
                                }
                                {
                                    moreResponse && more > 0 && 
                                    <p className="more-text" onClick={this.loadMore}>load more({more})</p>
                                }
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
        )
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/appointments/List.js